export default {
  top_text: `*Registrační poplatek činí <strong>300 Kč</strong> a je platný po dobu 3 let
            <strong>(všechny konzultace zdarma)</strong>. <br> U klientů nepojištěných v ČR se může cena lišit.`
}



// WEBPACK FOOTER //
// ./src/texts/czech/pricing.js